import styled from 'styled-components';
import {useTranslation} from 'next-i18next';
import {greenTransitColor, panelistaPrimaryColor} from 'src/utils/constants';
import DrawnArrow from '../../../public/images/drawnArrow.svg';
import {HandWriting} from '../landingStyledComponents';

const Container = styled.div`
  position: relative;
  transition: all 0.3s;

  @media (max-width: 900px) {
    transform: scale(0.8);
    margin: -60px 0;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`;

const Card = styled.div<{hoverable?: boolean}>`
  position: relative;
  width: 300px;
  height: 460px;
  background-color: #e0f6ec;
  box-shadow: 0px 14px 54px 0 rgba(0, 0, 0, 0.06);
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  justify-content: space-between;
  align-items: center;
  transition: transform 0.4s;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);

  &:hover {
    transform: ${(props) =>
      props.hoverable ? 'perspective(1000px) rotateX(-3deg) rotateY(14deg) rotateZ(-3deg)' : 'none'};
  }
`;

const CardText = styled.span`
  font-size: 20px;
  font-family: var(--font-jakarta);
  font-weight: 700;
`;

const Logo = styled.div`
  background-color: ${greenTransitColor};
  font-size: 16px;
  font-weight: 600;
  color: white;
  padding: 6px 10px;
  border-radius: 4px;
`;

const StyledDrawnArrow = styled(DrawnArrow)`
  position: absolute;
  bottom: 100px;
  right: -5%;
  transform: rotate(35deg);

  @media (max-width: 1280px) {
    display: none;
  }
`;

const StyledHandwriting = styled(HandWriting)`
  max-width: 200px;
  position: absolute;
  text-align: center;
  bottom: 180px;
  right: -67%;
  transform: rotate(-6deg);
  color: ${panelistaPrimaryColor};

  @media (max-width: 1280px) {
    display: none;
  }
`;

const QrCodeContainer = styled.div`
  width: 160px;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
`;

const TouchpointQRExampleGraphic = () => {
  const {t, i18n} = useTranslation();

  const touchpointUrl = `https://panelista.com/touchpoints/${
    i18n.language === 'sv' ? '6183dc27edb4650016f91a12' : '6183dc91edb4650016f91ad4'
  }`;

  return (
    <Container>
      <Card
        style={{
          position: 'absolute',
          transform: 'rotate(-10deg)',
          boxShadow: 'none',
          backgroundColor: '#D5EDE2',
          width: 280,
          height: 450
        }}
      />

      <a
        href={touchpointUrl}
        target="_blank"
        onClick={() => plausible('Touchpoint example clicked', {props: {place: 'Touchpoints', actor: 'Anders'}})}
      >
        <Card hoverable>
          <CardText dangerouslySetInnerHTML={{__html: t('website.touchpoints example two card text')}} />

          <QrCodeContainer>
            <img src={`/images/touchpointQrExample_${i18n.language}.svg`} style={{width: '100%', height: '100%'}} />
          </QrCodeContainer>

          <Logo>GREEN TRANSIT</Logo>
        </Card>
      </a>

      <StyledDrawnArrow />
      <StyledHandwriting>{t('website.scan with your phone')}</StyledHandwriting>
    </Container>
  );
};

export default TouchpointQRExampleGraphic;
